export const salesProducts = [
  {
    _id: "62a15fd93107f597ce83fbbe",
    productName: "Curtisii",
    price: 56,
    type: "Arodios",
    imgSrc: "https://sproutsandstems.com/wp-content/uploads/2021/10/Hoya-Curtisii.jpg"
  },
  {
    _id: "62a16bfb3107f597ce83fbcf",
    productName: "Foldable Shovel",
    price: 20,
    type: "Foldable Shovel",
    imgSrc: "https://www.equipoutdoors.co.nz/assets/full/EL1153.jpg?20210807133646"
  }
]

export const NewProds = [
  {
    _id: '62a15fd93107f597ce83fbbe',
    productName: 'Curtisii',
    imgSrc: 'https://sproutsandstems.com/wp-content/uploads/2021/10/Hoya-Curtisii.jpg',
    type: 'Hoya',
    price: 66
  },
  {
    _id: '62a1606a3107f597ce83fbc4',
    productName: 'Thailandica',
    imgSrc: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmhIqQMkQQZuNQCwJUjMZchawVDIVZTN-egQ&usqp=CAU',
    type: 'Hoya',
    price: 32
  },
  {
    _id: '62a1608a3107f597ce83fbc7',
    productName: 'Acuta',
    imgSrc: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHrE0imr5VBpjRyWAzsveYmJxtKCGcaIQEog&usqp=CAU',
    type: 'Hoya',
    price: 23
  },
  {
    _id: '62a160aa3107f597ce83fbca',
    productName: 'Obovata',
    imgSrc: 'https://cdn.shopify.com/s/files/1/0151/1650/1046/products/Hoya_obovata_indoor_pot_plant_ceramic_pot_new_zealand_540x.jpg?v=1622091417',
    type: 'Hoya',
    price: 21
  }
]

// Dev Dummy Data
export const allProducts = [
  {
    productName: 'Hoya Curtisii',
    imgSrc: 'https://sproutsandstems.com/wp-content/uploads/2021/10/Hoya-Curtisii.jpg',
    category: 'Hoyas',
    price: 66
  },
  {
    productName: 'Hoya Australis',
    imgSrc: 'https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcTbQMan1mo2TKT7PGveXQkur_uGSMx-zDSCQgQ8dbBfkNf4KvsnsIo-cyQyN3sgrR99pSIT2xVIQmHzNNgXOvYmBjrlZ8agqoAgvi534eX9mEoKmKyOXT2H5A&usqp=CAE',
    category: 'Hoyas',
    price: 99
  },
  {
    productName: 'Hoya thailandica',
    imgSrc: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmhIqQMkQQZuNQCwJUjMZchawVDIVZTN-egQ&usqp=CAU',
    category: 'Hoyas',
    price: 32
  },
  {
    productName: 'Hoya Acuta',
    imgSrc: 'https://trademe.tmcdn.co.nz/photoserver/plus/1737587042.jpg',
    category: 'Hoyas',
    price: 78
  },
  {
    productName: 'Hoya Obovata',
    imgSrc: 'https://cdn.shopify.com/s/files/1/0267/6840/8639/products/IMG_9922.jpg?v=1642307792&width=800',
    category: 'Hoyas',
    price: 29
  },
  {
    productName: 'Aroids Curtisii',
    imgSrc: 'https://sproutsandstems.com/wp-content/uploads/2021/10/Hoya-Curtisii.jpg',
    category: 'Aroids',
    price: 66
  },
  {
    productName: 'Aroids Australis',
    imgSrc: 'https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcTbQMan1mo2TKT7PGveXQkur_uGSMx-zDSCQgQ8dbBfkNf4KvsnsIo-cyQyN3sgrR99pSIT2xVIQmHzNNgXOvYmBjrlZ8agqoAgvi534eX9mEoKmKyOXT2H5A&usqp=CAE',
    category: 'Aroids',
    price: 99
  }
]

export const Hoyas = [
  {
    productName: 'Hoya Curtisii',
    imgSrc: 'https://sproutsandstems.com/wp-content/uploads/2021/10/Hoya-Curtisii.jpg',
    category: 'Hoyas',
    price: 66
  },
  {
    productName: 'Hoya Australis',
    imgSrc: 'https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcTbQMan1mo2TKT7PGveXQkur_uGSMx-zDSCQgQ8dbBfkNf4KvsnsIo-cyQyN3sgrR99pSIT2xVIQmHzNNgXOvYmBjrlZ8agqoAgvi534eX9mEoKmKyOXT2H5A&usqp=CAE',
    category: 'Hoyas',
    price: 99
  },
  {
    productName: 'Hoya thailandica',
    imgSrc: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmhIqQMkQQZuNQCwJUjMZchawVDIVZTN-egQ&usqp=CAU',
    category: 'Hoyas',
    price: 32
  }
]

export const Aroids = [
  {
    productName: 'Aroids Curtisii',
    imgSrc: 'https://sproutsandstems.com/wp-content/uploads/2021/10/Hoya-Curtisii.jpg',
    category: 'Aroids',
    price: 66
  },
  {
    productName: 'Aroids Australis',
    imgSrc: 'https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcTbQMan1mo2TKT7PGveXQkur_uGSMx-zDSCQgQ8dbBfkNf4KvsnsIo-cyQyN3sgrR99pSIT2xVIQmHzNNgXOvYmBjrlZ8agqoAgvi534eX9mEoKmKyOXT2H5A&usqp=CAE',
    category: 'Aroids',
    price: 99
  }
]